export interface PolicyListBlock {
    type: 'list';
    items: string[];
}

export interface PolicyLabeledListBlock {
    type: 'labeledList';
    items: { label: string; text: string }[];
}

export interface PolicyContactBlock {
    type: 'contact';
    items: { label: string; text: string }[];
}

export interface PolicyParagraphBlock {
    type: 'paragraph';
    text: string;
}

export interface PolicyHeadingBlock {
    type: 'heading';
    text: string;
}

export type PolicyBlock =
    | PolicyParagraphBlock
    | PolicyHeadingBlock
    | PolicyListBlock
    | PolicyLabeledListBlock
    | PolicyContactBlock;

export interface PolicySection {
    title: string;
    blocks: PolicyBlock[];
}

export interface LegalDocument {
    version: string;
    title: string;
    lastUpdated: string;
    effectiveAt: string;
    sections: PolicySection[];
}

export async function fetchLegalDocument<T extends LegalDocument>(
    url: string,
    fallbackUrl: string
): Promise<T> {
    const response = await fetch(url);

    if (response.ok) {
        return response.json() as Promise<T>;
    }

    if (url !== fallbackUrl) {
        const fallbackResponse = await fetch(fallbackUrl);
        if (fallbackResponse.ok) {
            return fallbackResponse.json() as Promise<T>;
        }
    }

    throw new Error('Document not found');
}
